import React from 'react';
import { createSvgIcon } from '../../icon';
/* eslint-disable max-len */
export default createSvgIcon('arrow-right', '0 0 96 96', React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M67.5 40.1L29.9 2.6c-1-1-2.4-1.6-3.8-1.6s-2.8.6-3.8 1.6-1.6 2.4-1.6 3.8.6 2.8 1.6 3.8l37.5 37.6v.7L22.4 85.9c-1 1-1.6 2.4-1.6 3.8s.6 2.8 1.6 3.8 2.4 1.6 3.8 1.6 2.8-.6 3.8-1.6L67.4 56l7.8-7.7-7.7-8.2z" })));
